import { back } from '../../../../../helpers/dataServer';

export const API_PURCHASE_SENT = `${back}/productos/sent`;
export const API_PURCHASE_ID = `${back}/productos/sentid/`;
